'use client';

import { useState, useEffect } from 'react';
import ApplicationForm from './ApplicationForm';

interface ForBuyersInteractiveProps {
  className?: string;
}

const ForBuyersInteractive = ({ className = '' }: ForBuyersInteractiveProps) => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) {
    return (
      <div className={`min-h-screen bg-background ${className}`}>
        <div className="animate-pulse">
          <div className="h-96 bg-primary/20"></div>
        </div>
      </div>
    );
  }

  return (
    <div className={`min-h-screen bg-background ${className}`}>
      <ApplicationForm />
    </div>
  );
};

export default ForBuyersInteractive;
